const state = () => ({
    _quickActionsDropdown: false,
    typeActionSelected: "",
    refresh: false
})

// getters
const getters = {
        quickActionsDropdown: (state) => {
            return state._quickActionsDropdown
        },
        typeActionSelected: (state) => {
            return state.typeActionSelected
        },
        refresh: (state) => {
            return state.refresh
        }
}
// mutations
const mutations = {
    SET_QUICKACTIONS(state, q) {
        state._quickActionsDropdown = q
    },
    SET_TYPE_ACTION_SELECTED(state, action) {
        state.typeActionSelected = action
    },
    SET_REFRESH(state, refresh) {
        state.refresh = refresh
    }
}

//actions
const actions = {
    setQuickActionsDropdown({ commit }, q) {
        commit('SET_QUICKACTIONS', q)
    },
    setTypeActionSelected({ commit }, action) {
        commit('SET_TYPE_ACTION_SELECTED', action)
    },
    setRefresh({ commit }, refresh) {
        console.log('globalVariables refresh', refresh);
        commit('SET_REFRESH', refresh)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}